import { createServerOnlyFn } from "@tanstack/react-start";
import { handleApplicationPhoneSignIn } from "./application-phone-sign-in.server.ts";

export const applicationPhoneSignInRoute = {
    server: {
        handlers: {
            POST: createServerOnlyFn(
                ({
                    request,
                    params,
                }: {
                    request: Request;
                    params: { token: string };
                }) => handleApplicationPhoneSignIn(request, params.token),
            ),
        },
    },
};
